import { CareProvider, CareProviderAsset, CareProviderAssetType } from '@providers/providers.types'

export const getCareProviderAsset = (prov: CareProvider | undefined, type: CareProviderAssetType) => {
  if (!prov) return ''

  const assets = prov.visualIdentity.assets
  const logo = assets.find((asset: CareProviderAsset) => asset.type === type)

  return logo ? logo.file : ''
}
